import { useController, useFormContext } from 'react-hook-form';
import InputComponent from './component';
import Colors from '../../../constants/colors';

const colors = [
  Colors.violet,
  Colors.blueLight,
  Colors.greenLight,
  Colors.yellow,
  Colors.redLight,
  Colors.linear06,
  Colors.shade09,
];

const FolderColorPicker = ({
  name,
  required = false,
  label,
  defaultValue = '',
  ...restProps
}) => {
  const { control } = useFormContext();

  const {
    field: { ref, ...inputProps },
  } = useController({
    name,
    control,
    rules: { required },
    defaultValue: colors[0],
  });

  return (
    <InputComponent
      {...inputProps}
      {...restProps}
      colors={colors}
      label={label}
      inputRef={ref}
    />
  );
};

export default FolderColorPicker;
